import { render, staticRenderFns } from "./CoachesTop.vue?vue&type=template&id=6883bfbe&lang=pug"
import script from "./CoachesTop.vue?vue&type=script&lang=js"
export * from "./CoachesTop.vue?vue&type=script&lang=js"
import style0 from "./CoachesTop.vue?vue&type=style&index=0&id=6883bfbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports